module.exports = __webpack_public_path__ + "img/public/SiteIcons/hostStepIcons/photos.svg?02840daa";